import { render, staticRenderFns } from "./ModuleEquivalent.vue?vue&type=template&id=85cd17fa"
import script from "./ModuleEquivalent.vue?vue&type=script&lang=js"
export * from "./ModuleEquivalent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports